import { GetPiecesJointesAsync } from '@/api/pieceJointes/index';

export default async function getLogoClient(client) {
  let id = client.id;
  let logo = (await GetPiecesJointesAsync(id)).data;
  if (!logo.chemin && client.tiersParentId) {
    id = client.tiersParentId;
    logo = (await GetPiecesJointesAsync(id)).data;
  }
  if (!logo.chemin && client.tiersParent && client.tiersParent.tiersParentId) {
    id = client.tiersParent.tiersParentId;
    logo = (await GetPiecesJointesAsync(id)).data;
  }
  return { logo: logo, id: id};
}
